
/* eslint-disable no-undef */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Carousel } from 'react-bootstrap';
import Lightbox from 'react-image-lightbox';
import MediaQuery from 'react-responsive';
import Cookies from 'js-cookie';
import ReadMore from '../../SharedComponents/ReadMore/ReadMore';
import MapDetailsComponent from './DetailsMap/MapDetailComponent';
import './DetailsLeftPart.sass';
import arrowOnButton from '../../../../../assets/images/icons/arrow-green.svg';
import markerImage1 from '../../../../../assets/images/mark_gray_1.gif';
import markerImage2 from '../../../../../assets/images/mark_gray_2.gif';
import markerImage3 from '../../../../../assets/images/mark_gray_3.gif';
import markerImage4 from '../../../../../assets/images/mark_gray_4.gif';
import markerImage5 from '../../../../../assets/images/mark_gray_5.gif';
import rentedImage from '../../../../../assets/images/rented-out.png';
import { StarRateIcon } from '../../SharedComponents/Icons';

class DetailsLeftPart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      photoIndex: 0,
      isOpen: false,
      locationOrdered: false,
      isMapHovering: false,
      staticImageAvailable: true,
    };
  }


  componentDidMount() {
    this.props.mapUrl ? this.setState({ staticImageAvailable: true }) : this.setState({ staticImageAvailable: false });

    if (typeof gtag === 'function') {
      gtag('event', 'view_item', this.generateGoogleData(this.props.location, 'Catalog'));
      if (Cookies.getJSON(`order${this.props.location.loc_id}`)) {
        this.setState({
          locationOrdered: true,
        });
      }
    }
  }

  handleAddingLocationToOrder = (location) => {
    const selectedLocationsIds = this.props.selectedLocations.map(loc => loc.loc_id);
    /* eslint-disable no-param-reassign */

    location.position_index = sessionStorage.getItem('my.details_location_index') || 0;
    /* eslint-disable no-param-reassign */
    gtag('event', 'add_to_cart', this.generateGoogleData(location, 'List-view'));

    if (selectedLocationsIds.indexOf(location.loc_id) === -1) {
      this.props.droppingAnimationStart(location);
    }
  };

  divideFacilitiesToChunk = (array, size) => {
    if (array.length === 0) {
      return <p>{I18n.t('location.detailed_view.no_facilities')}</p>;
    }
    const facilities = [];
    let i; let j; let temparray; const chunk = size;

    for (i = 0, j = array.length; i < j; i += chunk) {
      temparray = array.slice(i, i + chunk);
      facilities.push(temparray);
    }

    return facilities.map(chunks => (
      <tr key={chunks}>
        {chunks.map(elem => (
          <td key={elem}>{elem}</td>
        ))}
      </tr>
    ));
  };

  generateGoogleData = (location, listName) => ({
    items: [
      {
        id: location.loc_id.toString(),
        name: location.address_title,
        list_name: listName,
        category: location.category_for_ga,
        list_position: (sessionStorage.getItem('my.details_location_index') || 0).toString(),
        price: '1.0',
      },
    ],
  });

  capitalize = s => s[0].toUpperCase() + s.substr(1);

  handleMapMouseHover = ({ target }) => {
    if (!this.state.isMapHovering) {
      target.style.background = 'white';
      this.setState({ isMapHovering: true });
    }
  };



  render() {
    const { location, selectedLocations, mapUrl } = this.props;
    const { locationOrdered, isMapHovering, staticImageAvailable } = this.state;
    const iconArray = [markerImage1, markerImage2, markerImage3, markerImage4, markerImage5];
    const garellyImages = location.full_photos;
    const { photoIndex, isOpen } = this.state;
    const selectedLocationsIds = selectedLocations.map(loc => loc.loc_id);
    const locationsIsSelected = selectedLocationsIds.indexOf(location.loc_id) >= 0;
    const nearestLocationsPresent = location.nearest_locations.length > 0;
    const mapGridSize = nearestLocationsPresent ? 8 : 12;
    const priceInfo = location.state === 'closed'
      ? <p>{I18n.t('location.detailed_view.location_rented_out')}</p>
      : <p>{I18n.t('location.detailed_view.get_information_and_prices_html')}</p>;
    const mapContainerStyle = {
      position: 'absolute',
      objectFit: 'cover',
      width: '100%',
      height: '250px'
    };

    return (
      <div className="leftPart">
        <div className="readMoreContainer">
          <h1 className="main-color bold">
            {location.address_title}
          </h1>
          <div className="row details-page-block">
            <div className="col-sm-6">
              <div className="carouser-wrapper">
                <Carousel
                  indicators={false}
                  interval={0}
                  controls={location.photos_urls.length > 1}
                >
                  {location.photos_urls.map(elem => (
                    <Carousel.Item key={elem}>
                      <img width="100%" height={255} alt="900x500" src={elem} />
                      {location.state === 'closed' && (
                        <img
                          className="rented-image"
                          src={rentedImage}
                          alt="rented out"
                        />
                      )}
                    </Carousel.Item>
                  ))}
                </Carousel>

              </div>
              <button className="full-screen-garelly" type="button" onClick={() => this.setState({ isOpen: true })}>
                {I18n.t('location.detailed_view.view_pictures')}
              </button>

              {isOpen && (
                <Lightbox
                  mainSrc={garellyImages[photoIndex]}
                  nextSrc={garellyImages[(photoIndex + 1) % garellyImages.length]}
                  prevSrc={garellyImages[(photoIndex + garellyImages.length - 1) % garellyImages.length]}
                  onCloseRequest={() => this.setState({ isOpen: false })}
                  imagePadding={0}
                  enableZoom={false}
                  imageCaption={(
                    <div className="photo-caption">
                      <div className="numbers-of-photo">
                        <p>{`${photoIndex + 1} of ${garellyImages.length}`}</p>
                      </div>
                    </div>
                )}
                  onMovePrevRequest={() => this.setState({
                    photoIndex: (photoIndex + garellyImages.length - 1) % garellyImages.length,
                  })
                  }
                  onMoveNextRequest={() => this.setState({
                    photoIndex: (photoIndex + 1) % garellyImages.length,
                  })
                  }
                />
              )}

              <div className="office-description">
                <p>
                  {I18n.t('location.detailed_view.reference_number')}
                  <span>
                    {location.loc_id}
                  </span>
                </p>

                <p>
                  {I18n.t('location.detailed_view.office_size')}
                  <span>{location.area_humanized}</span>
                </p>

                <p>
                  {`${I18n.t('location.detailed_view.office_type')}: `}
                  <span>
                    { location.translated_kind }
                  </span>
                </p>

              </div>
            </div>
            <div className="col-sm-6">
              <div className="locations-rating">
                {[...Array(location.stars_rating)].map(elem => (
                  <StarRateIcon key={elem} />
                ))}
              </div>
              <ReadMore
                lines={11}
                more={I18n.t('list_view.read_more')}
                less={I18n.t('list_view.read_less')}
                readMore
                width={350}
              >
                <div className="location-description" dangerouslySetInnerHTML={{ __html: location.description }} />
              </ReadMore>
              <div className="add-report">
                {!locationsIsSelected && (
                  <button
                    type="button"
                    id={location.loc_id}
                    className={`getInfo-button ${locationsIsSelected ? 'button--disabled' : ''}`}
                    onClick={() => this.handleAddingLocationToOrder(location)}
                    disabled={locationOrdered || location.state === 'closed'}
                  >
                    <img className="green-arrow-cta" src={arrowOnButton} alt="" />
                    {I18n.t('location.detailed_view.get_information')}
                  </button>
                )}
                {locationsIsSelected && <p>{I18n.t('location.detailed_view.business_center_selected')}</p>}
              </div>
              { locationOrdered
                ? <p>{I18n.t('location.detailed_view.location_ordered')}</p>
                : priceInfo
              }

            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <h4 className="details-title">{I18n.t('location.detailed_view.facilities.title')}</h4>
              <div className="facilities-wrapper">
                <MediaQuery maxWidth={767}>
                  <table className="facily">
                    <tbody>
                      {this.divideFacilitiesToChunk(location.facilities, 2)}
                    </tbody>
                  </table>
                </MediaQuery>

                <MediaQuery minWidth={768}>
                  <table className="facily">
                    <tbody>
                      {this.divideFacilitiesToChunk(location.facilities, 3)}
                    </tbody>
                  </table>
                </MediaQuery>

              </div>
            </div>
          </div>

          <div className="row">
            <div className="nearest-map-section">
              <div className="col-md-12">
                <h4 className="details-title">
                  {I18n.t('location.detailed_view.property_located', { address: location.address_title })}
                </h4>
              </div>

              <div className="col-md-12"
                   onMouseEnter={this.handleMapMouseHover}
                   onTouchStart={this.handleMapMouseHover}
              >
                <div className={`col-sm-${mapGridSize} details-map-wrapper`}>
                  <div className="staticImage-wrapper">
                    {staticImageAvailable &&
                      <img
                        className='bottom-location-map lazyload'
                        src={mapUrl}
                        data-sizes="auto"
                        style={mapContainerStyle}
                      />
                    }
                    { (isMapHovering || !staticImageAvailable) &&
                      <MapDetailsComponent
                        lat={location.latitude}
                        long={location.longitude}
                        nearestLocations={location.nearest_locations}
                      />
                    }
                  </div>

                </div>
                {nearestLocationsPresent && (
                  <div className="col-sm-4 mapListWrapper">
                    <h4 className="details-title">{I18n.t('location.detailed_view.business_center_nearby')}</h4>
                    <ul>
                      {location.nearest_locations.map((elem, index) => (
                        <li key={elem.id}>
                          <div>
                            <img src={iconArray[index]} alt="nearest-marker" />
                          </div>
                          <a href={elem.url}>
                            {elem.address_title}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                )
                }
              </div>

            </div>
          </div>
        </div>
      </div>
    );
  }
}

DetailsLeftPart.propTypes = {
  location: PropTypes.oneOfType([PropTypes.object]),
  selectedLocations: PropTypes.arrayOf(PropTypes.object),
  droppingAnimationStart: PropTypes.func,
};

DetailsLeftPart.defaultProps = {
  location: [],
  selectedLocations: [],
  droppingAnimationStart: () => true,
};


export default DetailsLeftPart;
